import { jsx as _jsx } from 'react/jsx-runtime.js';
// this component is needed to wrap form elements and enable autoselect for Firefox users
export const AutoCompleteFormWrapper = ({ children }) => {
    const handleSubmit = (e) => {
        e.preventDefault();
    };
    return (_jsx("form", { autoComplete: "on", onSubmit: handleSubmit, action: "#", children: children }));
};
//# sourceMappingURL=AutoCompleteFormWrapper.js.map